



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../bus/events.const';
import { AnimateSizeToAuto } from '../pure/utils';

@Component
export default class SidePanel extends Vue {
  @Prop({ required: true })
  panelId: string;

  @Prop({ default: 'vertical' })
  layoutDirection: 'vertical' | 'horizontal';

  @Prop({ default: false })
  collapsible: boolean;

  @Prop({ required: true })
  collapsed: boolean;

  private animationName = '';

  get animateToAuto() {
    return this.layoutDirection === 'vertical' ? new AnimateSizeToAuto('width') : new AnimateSizeToAuto('height');
  }

  get directionClass() {
    return 'ebx-side-panel--' + this.layoutDirection;
  }

  mounted() {
    if (this.collapsible) {
      this.$x.emit(EVENTS.QuantumEntanglement, this.panelId);
      this.animationName = 'ebx-side-panel--collapsed';
    }
  }
}
